export default __webpack_public_path__ + "static/media/exam-illustration.f23fc67a.png";